<template>

<div class="filter">

    <app-icon name="filter" class="filter-open" v-on:click.native="onOpenClick" v-if="window.is.mobile" />

    <div class="filter-content" v-if="!window.is.mobile || is.expanded">

        <com-section :title="page.filter_search_title">

            <com-text v-model="filter.text" :placeholder="page.filter_search_placeholder" />

        </com-section>

        <com-section :title="page.filter_type_title">

            <com-checklist v-model="filter.type" :options="type" />

        </com-section>

        <com-section>

            <app-button theme="blue" :text="page.filter_general_reset" :expand="true" v-on:click="onResetClick" />
            <app-button v-if="window.is.mobile" theme="blue" :text="page.filter_general_close" :expand="true" v-on:click="onCloseClick" class="filter-close" />

        </com-section>

    </div>

</div>

</template>

<script>

import comSection from './../search/filter/Section'
import comText from './../search/filter/Text'
import comChecklist from './../search/filter/Checklist'

export default {

    data: function() {

        return {
            filter: {
                text: '',
                type: []
            },
            is: {
                expanded: false
            }
        }

    },

    components: {
        'com-section': comSection,
        'com-text': comText,
        'com-checklist': comChecklist
    },

    computed: {

        type: function() {

            return this.$constants.vacancy

        }

    },

    watch: {

        filter: {

            deep: true,

            handler: function(n) {

                this.$emit('change', n)

            }

        }

    },

    created: function() {

        this.filter.text = this.$route.query.text
        this.filter.type = (this.$route.query.type) ? this.numericArray(this.$route.query.type.split(',')) : []

    },

    methods: {

        onResetClick: function() {

            this.filter.type = []
            this.is.expanded = false

        },

        numericArray: function(values) {

            var numeric = []

            this.$_.each(values, function(value) {

                numeric.push(parseInt(value))

            })

            return numeric   

        },

        onCloseClick: function() {

            this.is.expanded = false

        },

        onOpenClick: function() {
        
            this.is.expanded = true

        }

    }

}

</script>

<style scoped>

.filter {
    width: 300px;
    margin-right: 20px;
}

.filter-content {
    flex-shrink: 0;
    border: 1px solid var(--color-grey-light);
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    width: 100%;
}

.is-tablet .filter {
    width: 240px;
}

.is-mobile .filter {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
}

.is-mobile .filter-content {
    width: 100%;
    margin-right: 0px;
    border: 0px;
    border-radius: 0px;
    position: fixed;
    left: 0px;
    top: 0px;
    bottom: 0px;
    overflow-y: scroll;
    z-index: 10000;
    background-color: #fff;
}

.filter-close {
    margin-top: 4px;
}

.filter-open {
    width: 40px;
    height: 40px;
    border-radius: 4px;
    background-color: var(--color-blue-light);
    color: #fff;
    text-align: center;
    line-height: 40px;
    position: absolute;
    left: 5px;
}

</style>
